import { defineComponent as _defineComponent } from 'vue'
import { NeoButton, NeoField } from '@kodadot1/brick'

export interface Props {
  disabled?: boolean
  expanded?: boolean
  icon?: string
  label: string
  loading?: boolean
  type?: string
  size?: 'small' | 'medium' | 'large'
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SubmitButton',
  props: {
    disabled: { type: Boolean, default: false },
    expanded: { type: Boolean },
    icon: { default: 'paper-plane' },
    label: null,
    loading: { type: Boolean, default: false },
    type: { default: 'is-primary' },
    size: { default: 'medium' }
  },
  setup(__props: any) {



return { __sfc: true,NeoButton, NeoField }
}

})